import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { RootRedirect } from './components/RootRedirect';
import { authRoutes } from './config/authRoutes';
import { suiteRoutes } from './config/suiteRoutes';
import { legacyRoutes } from './config/legacyRoutes';
import { kdsRoutes } from './config/kdsRoutes';

/**
 * Main Routes Component
 * 
 * Organizes all application routes in a clean, maintainable structure.
 * Routes are grouped by domain/feature for better organization.
 * 
 * Note: POS, Dashboard, TDS, and Superadmin routes are now handled by their standalone apps.
 */
export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Authentication Routes */}
      {authRoutes}

      {/* Suite Routes (Accounts, Employee, Settings, Marketing, Retail, Dry Cleaning, Laundry, Fulfillment, Labels) */}
      {suiteRoutes}

      {/* Legacy Routes (for backward compatibility) */}
      {legacyRoutes}

      {/* KDS Routes */}
      {kdsRoutes}

      {/* Root Redirect */}
      <Route path="/" element={<RootRedirect />} />
    </Routes>
  );
};
